import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Checkbox, Form, Label } from 'semantic-ui-react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import Scrollbar from '../../components/scrollbar';
import { Link } from 'react-router-dom';
import SelectHuntingClub, { components } from 'react-select';

export default function Create(props) {
	
	const navigate  = useNavigate();
	
	const [broj, setBroj] = useState('');	
	const [huntingclubId, setHuntingClubId] = useState('');
	const [naziv, setNaziv] = useState('');
	const [lokacija, setLokacija] = useState('');
	const [opis, setOpis] = useState('');
	const [godina, setGodina] = useState('');
    const [napomena, setNapomena] = useState('');
	
	const [selectedOption, setSelectedOption] = useState(null);
	const [huntingclubs, setHuntingClubs] = useState(null);
	const [huntingclubsdataloaded, setHuntingClubsDataLoaded] = useState(null);
	const [selecthuntingclubsdataloaded, setSelectHuntingClubsDataLoaded] = useState(null);
	const [awardtypeId, setAwardTypeId] = useState('1');
	const [options, setOptions] = useState('');
	const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
	useEffect(() => {
		if (!huntingclubsdataloaded) {
			getHuntingClubsAll();
		}
		
		if (huntingclubsdataloaded && !selecthuntingclubsdataloaded) {
			FillSelectHuntingClubsAll();
		}
		
		
	});
	
	const getHuntingClubsAll = async () => {
      try {
		const response = await axios.get(SERVER_URL + "/huntingclubs/");
        setHuntingClubs(response.data);
		setHuntingClubsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
	};
	
	const FillSelectHuntingClubsAll = async () => {
      try {
		setSelectHuntingClubsDataLoaded(true);
		const clubs = [];
		huntingclubs.map((huntingclub, index) => ( clubs.push({ value: huntingclub.id, label: huntingclub.naziv, icon: huntingclub.flag })));
		console.log(clubs);
		setOptions(clubs);
      } catch (err) {
        console.log("error");
      }
	};

    const handleChangeHuntingClub = e => {
    setSelectedOption(e);
    console.log(e);
	setHuntingClubId(e.value);
  }	
		
	const postData = () => {	
	  console.log(broj);
	  console.log(huntingclubId);
	
	
		axios.post(SERVER_URL + "/buildings",
			{
				"broj": broj,
				"huntingclubId": huntingclubId,
				"naziv": naziv,
				"lokacija": lokacija,
				"opis": opis,
				"godina": godina,
				"napomena": napomena
			}
			).then(() => {
				props.handler();
            // navigate('/dashboard/app')
        })
	}
	
  const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  selectimage: {
    margin: 0,
	paddingTop : 0,
	padding : 0,
	height: 40,
	paddingHorizontal: 10,
  },
  selecttext: {
    margin: 3,
    fontSize: 16,
    textAlign: 'justify',
	paddingHorizontal: 20,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    width: "10%", 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
  });
	
  const customStyles = {
  control: base => ({
    ...base,
	width: 300,
    height: 45,
    minHeight: 25,
	fontSize: 16,
  })
};
  
  const { Option } = components;
  const IconOption = props => (
	<Option {...props}>
	<TableRow style={styles.selectimage}>
	
	<TableCell style={styles.selectimage} align="left">
	
	    <Stack direction="row" alignItems="center" spacing={2}>
		
            <Avatar alt={props.data.label} src={props.data.icon} />
							
			<Typography style={styles.textmedium} variant="subtitle2" noWrap>
				
			</Typography>
			
        </Stack>
						  
	</TableCell>
	
	<TableCell style={styles.selectimage} align="left">
	<Typography style={styles.selecttext} variant="subtitle2" noWrap>
	{props.data.label}
	</Typography>
	</TableCell>
							
	</TableRow>
	</Option>
  );
		
    return (
		<Container maxWidth="xl">
        <Card>
          <Scrollbar>
		  
		    <TableContainer sx={{ minWidth: 800 }}>
			
              <Table style={{ tableLayout: 'fixed', color: "FF00FF" }}>
			  
                <TableBody>
        
                <TableRow>
					<TableCell component="th" scope="row" >
					<FormControl>
						<Label>Lovačko društvo</Label>
							<SelectHuntingClub 
							menuPortalTarget={document.body} 
							menuPosition={'fixed'}
							defaultValue={options[0]}
							options={options}
							components={{ Option: IconOption }}
							onChange={handleChangeHuntingClub}
							styles={customStyles}
						    />
					</FormControl>
					</TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Inventarski broj</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setBroj(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Naziv</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setNaziv(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" >
						<Label>Lokacija</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setLokacija(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
						
                </TableRow>
				
                <TableRow>
					<TableCell component="th" scope="row" >
					<FormControl>
						<Label>Lovačko društvo</Label>
							<SelectHuntingClub 
							menuPortalTarget={document.body} 
							menuPosition={'fixed'}
							defaultValue={options[0]}
							options={options}
							components={{ Option: IconOption }}
							onChange={handleChangeHuntingClub}
							styles={customStyles}
						    />
					</FormControl>
					</TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Inventarski broj</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setBroj(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Naziv</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setNaziv(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" >
						<Label>Lokacija</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setLokacija(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
						
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
          </Scrollbar>

        </Card>
        </Container>
    )
}